import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { AdminHome } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <AdminHome />
    </RouteGuard>
  ),
});
